/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description DeleteWriteOffReason Modal
 */
import { Button, ButtonProps, App, Tooltip } from 'antd';
import { DeleteOne } from '@icon-park/react';

import { MODAL_TYPES } from '../modal';
import useDeleteWriteOffReason from 'hooks/admin/mutate/useDeleteWriteOffReason';
import { useAppStoreValues } from 'store/app';
import { NO_ACCESS_TOOLTIP_TEXT } from '@veritable/common/constants';

export interface IProps extends ButtonProps {
	reason: EntitySettings.IWriteOffReasonResponse;
}

/**
 * DeleteClaimAction
 * @returns {React.FC<IProps>} DeleteClaimAction
 */

const DeleteWriteOffReason: React.FC<IProps> = ({ reason, ...restProps }) => {
	const { modal } = App.useApp();
	const { mutateAsync } = useDeleteWriteOffReason();
	const { canEditClaims } = useAppStoreValues().userAccess;
	const disabled = restProps.disabled || !canEditClaims;
	const handleDelete = () => {
		modal.confirm({
			...MODAL_TYPES.confirm,
			width: 560,
			title: 'Delete Write-Off Reason',
			content:
				'Are you sure you want to delete this write-off reason? If no claims use this reason, it will be permanently removed. Otherwise, it will be marked as disabled.',
			okText: 'Delete',
			okButtonProps: { danger: true },
			cancelText: 'Cancel',
			onOk: async () => {
				await mutateAsync({ model: { writeOffReasonId: reason.id } });
			},
		});
	};

	return (
		<Tooltip title={canEditClaims ? 'Delete' : NO_ACCESS_TOOLTIP_TEXT}>
			<Button danger icon={<DeleteOne />} onClick={handleDelete} {...restProps} disabled={disabled} />
		</Tooltip>
	);
};

export default DeleteWriteOffReason;
